import { Gender } from "../enums/Gender";

export class Person {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
    gender: Gender | undefined;
    birthDate: Date;
    ssn: string;
    
    constructor(firstName?: string, lastName?: string) {
      this.firstName = firstName || "";
      this.middleName = "";
      this.lastName = lastName || "";
      this.suffix = "";
      this.gender = undefined;
      this.birthDate = new Date("");
      this.ssn = "";
    }
}